import { useEffect } from 'react';

import { usePsfSharePageData, usePsfSharePageFcm } from 'src/app/pages/psf/share/pageContext';
import type { ShareFeedItem } from 'src/app/pages/psf/share/pageContext';
import { usePageCopy } from 'src/app/pages/psf/share/shared/hooks';
import { useTrackOnce } from 'src/app/shared/hooks/tracking';

type Result = ModelHookResult<{
	heading: string;
	subHeading: string;
	warning?: string;
	shareFeed: {
		items: readonly ShareFeedItem[];
		showOnMobile: boolean;
		showOnDesktop: boolean;
	};
	isPsfOnlyShare: boolean;
}>;

const MIN_SHARES_MOBILE = 3;
const MIN_SHARES_DESKTOP = 12;

export function usePageBody(): Result {
	const {
		data: { headingText, subheadingText },
	} = usePageCopy();
	const { warningMessage, psfOnlyShareButtonList } = usePsfSharePageFcm();
	const {
		data: { shareFeed },
	} = usePsfSharePageData();
	const trackOnce = useTrackOnce();

	const showOnMobile = shareFeed.length >= MIN_SHARES_MOBILE;
	const showOnDesktop = shareFeed.length >= MIN_SHARES_DESKTOP;

	useEffect(() => {
		if (!showOnMobile && !showOnDesktop) return;
		void trackOnce('share_feed_view', {
			share_feed_item_count: shareFeed.length,
			share_feed_photo_count: shareFeed.filter((item) => !!item.userPhoto).length,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [trackOnce]);

	return {
		data: {
			heading: headingText,
			subHeading: subheadingText,
			warning: warningMessage,
			shareFeed: {
				items: shareFeed,
				showOnMobile,
				showOnDesktop,
			},
			isPsfOnlyShare: psfOnlyShareButtonList.length > 0,
		},
	};
}
